import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _ from 'lodash';

var log = require('loglevel').getLogger('core/utils/auth-helper');

export var auth = null;
export function hasRight(a, b) {
  return _.includes(a, b);
}
export function hasRole(a, b) {
  return _.includes(a, b);
}
export function hasSomeRight(a, b) {
  return _.intersection(a, b).length > 0;
}
export function hasSomeRole(a, b) {
  return _.intersection(a, b).length > 0;
}

var Auth = /*#__PURE__*/function () {
  function Auth(menu, pages) {
    _classCallCheck(this, Auth);

    this.menu = menu;
    this.pages = pages;
  }

  _createClass(Auth, [{
    key: "hasPageRight",
    value: function hasPageRight(rights, page) {
      return hasSomeRight(rights, this.pages[page] ? this.pages[page].rights : false);
    }
  }, {
    key: "hasPageRole",
    value: function hasPageRole(roles, page) {
      return hasSomeRole(roles, this.pages[page] ? this.pages[page].roles : false);
    }
  }, {
    key: "getPages",
    value: function getPages(rights, roles, menuItemKey) {
      var _this = this;

      var pages = [];

      var menuItem = _.find(this.menu, {
        key: menuItemKey
      });

      if ((rights && rights.length > 0 || roles && roles.length > 0) && menuItem) {
        pages = _.filter(menuItem.pages, function (page) {
          return _this.hasPageRight(rights, page) || _this.hasPageRole(roles, page);
        });
      }

      log.debug('getPages', {
        rights: rights,
        roles: roles,
        pages: pages
      });
      return pages;
    }
  }, {
    key: "getMenu",
    value: function getMenu(rights) {
      var _this2 = this;

      var menu = [];

      if (rights && rights.length > 0) {
        menu = _.reduce(this.menu, function (acc, menuItem) {
          var key = menuItem.key,
              pages = menuItem.pages;

          var children = _.filter(pages, function (o) {
            return o !== key;
          });

          var isChildrenBak = false;

          for (var i = 0; i < children.length; i++) {
            if (children[i].indexOf('.bak') === -1) {
              isChildrenBak = false;
              break;
            }

            isChildrenBak = true;
          }

          pages = _.filter(pages, function (page) {
            return _this2.hasPageRight(rights, page);
          });

          if (pages.length > 0 && !isChildrenBak) {
            acc.push({
              key: key,
              pages: pages
            });
          }

          return acc;
        }, []);
      }

      log.debug('getMenu', {
        rights: rights,
        menu: menu
      });
      return menu;
    }
  }]);

  return Auth;
}();

export function create(menu, pages) {
  auth = new Auth(menu, pages);
  return auth;
}
export default {
  hasRole: hasRole,
  hasRight: hasRight,
  hasSomeRole: hasSomeRole,
  hasSomeRight: hasSomeRight,
  auth: auth,
  create: create
};